(() => {
  let runtime;
  const bound = new WeakSet();
  const activate = async drawer => {
    if (!drawer.classList.contains('show') && !drawer.classList.contains('showing')) return;
    try {
      runtime ||= import(drawer.dataset.runtimeUrl);
      (await runtime).mount(drawer);
    } catch {
      runtime = null;
    }
  };
  const bind = () => {
    const drawer = document.querySelector('.vhalam-cart');
    if (!drawer || bound.has(drawer)) return;
    bound.add(drawer);
    drawer.addEventListener('show.bs.offcanvas', () => {
      runtime ||= import(drawer.dataset.runtimeUrl);
      runtime.catch(() => { runtime = null; });
    });
    drawer.addEventListener('shown.bs.offcanvas', () => activate(drawer));
    activate(drawer);
  };
  document.addEventListener('shopify:section:load', bind);
  bind();
})();
